/* eslint-disable no-useless-catch */

import { api } from "./client";

class userService {
    static async getBuyoutQuote(accountNumber, leaseNumber, isEquipmentReturn) {

        const url = `/accounts/${accountNumber}/leases/${leaseNumber}/buyoutQuote/${isEquipmentReturn}`;
        try {
            const response = await api.get(url);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async getStatementDocument(billingHistory, accountNumber) {
        const url = `/accounts/${accountNumber}/statementLink`;
        const result = await api.post(url, billingHistory);
        return result.data;
    }
    
    static async setDefaultAccount(userId, userAccount){

        userAccount.IsDefault = true;
        const url = `/users/${userId}/accounts/${userAccount.Account.AccountNumber}`;

        var response = await api.patch(url, userAccount);
        return response;
    }

    static async getAccounts(userId) {
        const url = `/users/${userId}/accounts`;
        try {
            const response = await api.get(url);
            const accountData = response.data;
            const accounts = accountData.map(a => ({
                value: a.Account.AccountNumber,
                label: a.Account.AccountNumber + ': ' + a.Account.Name,
                name: a.Account.Name,
                data: a
            }));
            return accounts;
        } catch (error) {
            throw error;
        }
    }

    static async getApplications(email) {        
        const url = `/applications?email=${encodeURIComponent(email)}`;
        const compare = (a, b) => {
            const appNumberA = parseInt(a.ApplicationNumber);
            const appNumberB = parseInt(b.ApplicationNumber);
            return appNumberA - appNumberB;
        }
        try {
            const response = await api.get(url);
            const applications = response.data;
            const sortedApps = applications.sort(compare);
            return sortedApps;
        } catch (error) {
            throw error;
        }
    }

    static async getGuarantorApplications(email) {        
        const url = `/applications/guarantor?email=${encodeURIComponent(email)}`;
        try {
            const response = await api.get(url);
            const guarantors = response.data;
            return guarantors;
        } catch (error) {
            throw error;
        }
    }
    //[Route("guarantor/{email}/guarantor/{leaseAppGuarantorId}")]
    static async getGuarantorApplication(email, leaseAppQueueId) {
        const url = `/applications/guarantor/${leaseAppQueueId}?email=${encodeURIComponent(email)}`;
        try {
            const response = await api.get(url, {
                transformResponse: data => {
                    return JSON.parse(data, (name, value) => {
                        return value === null ? '' : value;
                    });
                }
            });
            let application = response.data;
            const defaultApplications = {
                AgreeToAdopt: false,
                AuthorizedDate: '',
                AgreeTermsAbove: false,
                AuthorizedSignature: ''
            };
            application = { ...defaultApplications, ...application };

            return application;
        } catch (error) {
            throw error;
        }
    }

    static async getLeases(accountNumber) {
        const url = `/accounts/${accountNumber}/leases`;
        try {
            const response = await api.get(url);
            const leases = response.data.map(a => ({
                value: a.Lease.LeaseNumber,
                label: `${a.Lease.LeaseNumber} ${a.Lease.Name}`,
                name: a.Lease.CustomerReference,
                data: a
            }));

            return leases;
        } catch (error) {
            throw error;
        }
    }
    static async checkUserData(userId) {
        try {
            const response = await api.get(`users/${userId}/checkUserData`);
            return response.data;
        } catch (error) {
            return error;
        }
    }

    static async getSecurityQuestions() {
        try {
            const response = await api.get('securityQuestions');

            const questions = response.data.Data;

            const mapToValueLabel = q => {
                return { value: q.Id, label: q.Question };
            };

            return {
                questions1: questions
                    .filter(q => q.QuestionSet === 1)
                    .map(mapToValueLabel),

                questions2: questions
                    .filter(q => q.QuestionSet === 2)
                    .map(mapToValueLabel),

                questions3: questions
                    .filter(q => q.QuestionSet === 3)
                    .map(mapToValueLabel)
            };
        } catch (error) {
            return error;
        }
    }

    static async checkAccountDetails(accountNumber, ssn, address) {
        const payload = {
            params: {
                accountNumber,
                ssn
            },
            data: {
                ZipCode: address?.zip
            }
        };

        const response = await api.post('users/checkAccountDetails', payload);
        return response;
    }

    static async getStates() {
        const statesResponse = await api.get('states');
        const states = statesResponse.data.map(s => {
            return { value: s.Code, label: s.Name };
        });
        return states;
    }
}

export default userService;
